<script setup lang="ts">
import { BTabs } from '@/design-system';
import { useTranslation } from '@/composables';
import { computed, onMounted } from 'vue';

type PropsType = {
    color?: string;
    density?: 'comfortable' | 'compact';
    grow?: boolean;
    vertical?: boolean;
    tabsContentClasses?: string;
    validation?: boolean;
};

withDefaults(defineProps<PropsType>(), {
    color: 'primary',
    density: 'comfortable',
    grow: false,
    vertical: false,
    validation: false,
});

const activeLanguage = defineModel<string>('modelValue', { default: 'cs' });
const { getContentLanguages, fetchLanguages } = useTranslation();

const languageTabs = computed(() =>
    getContentLanguages().map(lang => ({
        id: lang.value,
        title: lang.name,
    })),
);

onMounted(async () => {
    await fetchLanguages();
});
</script>

<template>
    <BTabs
        v-model="activeLanguage"
        :tabs="languageTabs"
        :color="color"
        :density="density"
        :grow="grow"
        :vertical="vertical"
        :tabs-content-classes="tabsContentClasses"
        :validation="validation"
    >
        <template
            v-for="language in getContentLanguages()"
            :key="language.value"
            #[language.value]="{ tab, active }"
        >
            <slot
                :name="language.value"
                :language="language"
                :tab="tab"
                :active="active"
            />
        </template>

        <template
            v-if="$slots.append"
            #append
        >
            <slot name="append" />
        </template>
    </BTabs>
</template>
